/**
 * API请求配置
 * 职责：HTTP请求相关配置
 */

import { ENV_CONFIG } from './env.config';

export const API_CONFIG = {
  // 基础URL
  BASE_URL: ENV_CONFIG.API_BASE_URL,
  
  // 请求超时（毫秒）
  TIMEOUT: parseInt(process.env.REACT_APP_REQUEST_TIMEOUT) || 30000,
  
  // 重试配置
  RETRY_TIMES: 3,
  RETRY_DELAY: 1000,
  
  // 请求头
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
};

export default API_CONFIG;

